import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';
import { useRegionalLink } from 'hooks/useRegionalLink';

import {
  Icon,
  Heading,
  Text,
  ItemArrow
} from 'components/common/Elements/Elements';

import classes from './PlatformItem.module.scss';

const PlatformItem = ({ item }) => {
  const generateRegionalPath = useRegionalLink();

  return (
    <div className={classes.platform}>
      <div className={classes.left}>
        <div className={classes.icon_wrap}>
          <Icon icon={item.icon} className={classes.icon} size="16px" />
        </div>
        <div className={classes.info}>
          <div className={classes.titleWrap}>
            <Heading>{item.title}</Heading>
            {item.notif && (
              <div className={classes.notifWrap}>
                <div
                  className={classes.marker}
                  style={{ backgroundColor: item.notif.markerColor }}
                />
                <Text className={classes.notif} size={4} weight="b">
                  {item.notif.text}
                </Text>
              </div>
            )}
          </div>
          {!item.url2 ? (
            <Text size={4}>{item.description}</Text>
          ) : (
            <div>
              {!item.disabled ? (
                <NavLink
                  className={cn(classes.link)}
                  to={generateRegionalPath(item.url)}
                >
                  {item.description}
                </NavLink>
              ) : (
                <Text className={cn(classes.link, classes.link_disabled)}>
                  {item.description}
                </Text>
              )}
              {!item.disabled2 ? (
                <NavLink
                  className={cn(classes.link)}
                  to={generateRegionalPath(item.url2)}
                >
                  {item.description2}
                </NavLink>
              ) : (
                <Text className={cn(classes.link, classes.link_disabled)}>
                  {item.description2}
                </Text>
              )}
            </div>
          )}
        </div>
      </div>
      {!item.url2 && (
        <ItemArrow
          route={generateRegionalPath(item.url)}
          disabled={item.disabled}
        />
      )}
    </div>
  );
};

PlatformItem.propTypes = {
  item: PropTypes.shape({
    icon: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    description2: PropTypes.string,
    url: PropTypes.string,
    url2: PropTypes.string,
    disabled: PropTypes.bool,
    disabled2: PropTypes.bool,
    notif: PropTypes.oneOfType([PropTypes.bool, PropTypes.object])
  })
};

export default PlatformItem;
